import { IOrder } from '@/interfaces/order';
import React from 'react';

interface IProps {
  data?: IOrder;
  docNo?: string;
}

const TemplateFooterExport = ({ docNo }: IProps) => {
  return (
    <div
      style={{
        position: 'absolute',
        left: 0,
        bottom: 0,
        width: '100%',
        padding: '20px',
      }}
    >
      <div className="flex justify-end text-xs">Document No: {docNo}</div>
    </div>
  );
};

export default TemplateFooterExport;
